export default __webpack_public_path__ + "locales/sr-Latn-RS/JavascriptSdk.json?hash=341660a491c860a05fc4a8377db2e63a";